const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function parseDate(iso) {
  if (!iso) return null;
  const d = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso);
  return isNaN(d.getTime()) ? null : d;
}

export function formatDate(iso) {
  const d = parseDate(iso);
  if (!d) return "—";
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export function formatDateShort(iso) {
  const d = parseDate(iso);
  if (!d) return "—";
  return `${d.getDate()} ${MONTHS[d.getMonth()]}`;
}

export function recurLabel(freq, iso) {
  if (!freq || freq === "None") return "";
  const d = parseDate(iso);
  if (!d) return freq;
  if (freq === "Monthly" || freq === "Quarterly" || freq === "6 Monthly") return `${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
  if (freq === "Yearly") return `${d.getFullYear()}`;
  return formatDate(iso);
}

export function relativeDays(iso) {
  const d = parseDate(iso);
  if (!d) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  d.setHours(0, 0, 0, 0);
  return Math.round((d - today) / 86400000);
}

export function dueLabel(iso) {
  const n = relativeDays(iso);
  if (n === null) return "No date";
  if (n === 0) return "Today";
  if (n === 1) return "Tomorrow";
  if (n === -1) return "Yesterday";
  if (n < 0) return `${Math.abs(n)}d overdue`;
  return `In ${n}d`;
}

export function initials(name) {
  if (!name) return "?";
  return name
    .split(" ")
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export function formatMoney(n) {
  if (n === null || n === undefined || n === "") return "—";
  const num = Number(n);
  if (isNaN(num)) return "—";
  return "$" + num.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function formatSize(opp) {
  const v = opp?.size_value;
  if (v === null || v === undefined || v === "") return "—";
  const num = Number(v);
  if (isNaN(num)) return "—";
  const metric = opp.size_metric || "";
  const period = opp.size_period === "Monthly" ? "Mth" : opp.size_period === "Annual" ? "Annual" : "";
  const amount =
    metric === "Revenue"
      ? formatMoney(num)
      : num.toLocaleString("en-AU") + (metric ? ` ${metric}` : "");
  return period ? `${amount} · ${period}` : amount;
}

export function formatDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleString("en-AU", { day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit" });
}
